export default {
  INVESTOR_GOAL_DATES_REPOSITORY: Symbol.for('INVESTOR_GOAL_DATES_REPOSITORY'),
  UPDATE_INVESTOR_GOAL_DATES_COMMAND: Symbol.for('UPDATE_INVESTOR_GOAL_DATES_COMMAND'),
};
